import * as React from 'react'

import { ActiveFeedStatus, INACTIVE_INTEGRATION_STATUS } from '../../types'
import { IframeLink } from '../iframe-link'
import { showIntercom } from '../../utils/iframe'
import { ContactSupportTypography, DetailsTypography } from './status-card.styles'

const detailsText = {
	[ ActiveFeedStatus.CONNECTED ]: {
		heading: 'Feed updating successfully.',
		details: 'Trackers are ready to assign to T3 assets. ',
	},
	[ ActiveFeedStatus.PENDING ]: {
		heading: 'Credentials saved.',
		details: 'We\'re working on getting tracker feeds from your OEM.',
	},
	[ ActiveFeedStatus.DELAYED ]: {
		heading: 'Feed update delayed.',
		details: 'We\'ll keep trying to connect.',
	},
	[ ActiveFeedStatus.AUTH_FAILED ]: {
		heading: 'Invalid credentials.',
		details: 'Check and re-enter your integration credentials below.',
	},
	[ ActiveFeedStatus.UNRESPONSIVE ]: {
		heading: 'It\'s been a while since we successfully received an update.',
		details: 'We may need support\'s help to figure out why. ',
	},
	[ ActiveFeedStatus.ACTION_NEEDED ]: {
		heading: 'Setup incomplete.',
		details: 'Enable T3 access below to finish setting up this integration.',
	},
	[ ActiveFeedStatus.STATUS_UNSPECIFIED ]: {
		heading: 'Feed status unknown.',
		details: 'Unable to determine feed status. ',
	},
	[ INACTIVE_INTEGRATION_STATUS ]: {
		heading: 'Feed paused.',
		details: 'This feed has been temporarily disabled and is not receiving updates. If this is unexpected, ',
	},
}

export const StatusDetails: React.FC<{
	status: ActiveFeedStatus,
	onLinkClick?: ( title: string ) => void,
	trackerAssignmentHelpURL?: string,
	name?: string,
}> = ( { status, onLinkClick, trackerAssignmentHelpURL, name } ) => {
	const onInactiveLinkClick = () => {
		onLinkClick?.( 'Contact Support' )
		showIntercom( `I'm having trouble with my ${name} integration.` )
	}

	const shouldShowTrackerAssignmentURL = status === ActiveFeedStatus.CONNECTED && trackerAssignmentHelpURL

	return (
		<DetailsTypography variant="body2" component="span">
			<b>{detailsText[ status ].heading}</b> {detailsText[ status ].details}
			{shouldShowTrackerAssignmentURL && (
				<IframeLink
					href={trackerAssignmentHelpURL}
					target="_blank"
					onClick={() => onLinkClick?.( 'Learn More' )}
				>
					Learn more
				</IframeLink>
			)}
			{status === ActiveFeedStatus.UNRESPONSIVE && <ContactSupportTypography onClick={onInactiveLinkClick}>Contact Support</ContactSupportTypography>}
		</DetailsTypography>
	)
}
